module.exports = __webpack_public_path__ + "static/img/sample-map.5ce05cc.png";